import { T } from '@tolgee/react'
import axios from 'axios'
import { ViewContext } from 'components/lib'
import { useCallback, useContext, useEffect, useState } from 'react'

export const useGalleries = () => {
  const context = useContext(ViewContext)

  const [galleries, setGalleries] = useState({ isLoading: true, data: [] })
  const [selectedGallery, setSelectedGallery] = useState()
  const [galleryItems, setGalleryItems] = useState({ isLoading: false, data: [] })
  const [search, setSearch] = useState('')

  const fetchGalleries = useCallback(async () => {
    try {
      const res = await axios.get('/api/gallery/list')

      setGalleries({
        isLoading: false,
        data: res.data?.map((gallery) => ({
          value: gallery.id,
          label: gallery.name ?? <T keyName='eleo-default-gallery-name'>Default</T>,
          isMediaGallery: gallery.isMediaGallery ?? false,
        })),
      })
      if (!selectedGallery) {
        const gallery = res.data.find((g) => !g.isMediaGallery)

        setSelectedGallery({
          value: gallery.id,
          label: gallery.name ?? <T keyName='eleo-default-gallery-name'>Default</T>,
          isMediaGallery: gallery.isMediaGallery,
        })
      }
    } catch (err) {
      context.handleError(err)
    }
  }, [selectedGallery])

  useEffect(() => {
    fetchGalleries()
  }, [fetchGalleries])

  const fetchItems = useCallback(async () => {
    try {
      setGalleryItems({ isLoading: true, data: [] })
      const url = selectedGallery.isMediaGallery ? '/api/media-gallery' : '/api/gallery'
      const res = await axios.get(url, { params: { id: selectedGallery.value } })
      setGalleryItems({ isLoading: false, data: res.data })
    } catch (err) {
      context.handleError(err)
      setGalleryItems({ isLoading: false, data: [] })
    }
  }, [selectedGallery])

  useEffect(() => {
    if (selectedGallery) {
      fetchItems()
    }
  }, [selectedGallery, fetchItems])

  return {
    galleries,
    galleryItems,
    gallerySearch: search,
    setGallerySearch: setSearch,
    selectedGallery,
    setSelectedGallery,
    setGalleryItems,
    fetchGalleries,
    fetchItems,
  }
}
